import { useParams } from "wouter";
import { useAssets } from "@/contexts/AssetContext.jsx";
import { useDowntime } from "@/contexts/DowntimeContext.jsx";
import { findAssetByRouteId } from "@/lib/asset-data-utils.js";
import AssetLayout from "./asset-layout.jsx";
import { useAssetTagTrend } from "@/hooks/useAssetTagTrend.js";
import AssetTagTrend from "@/components/asset-tag-trend.jsx";

/**
 * Asset Trends page component
 * Displays tag panel and trend analysis panel for detailed tag trends
 * @returns {JSX.Element} Asset Trends page
 */
export default function AssetTrends() {
  const { id } = useParams();
  const { assets: compressors } = useAssets();
  const { downtimeEvents } = useDowntime();
  const compressor = findAssetByRouteId(compressors, id);

  // Use shared hook for all tag and trend-related logic
  const tagTrendData = useAssetTagTrend(compressor);

  if (!compressor) {
    return null;
  }

  return (
    <AssetLayout>
      <div className='w-full max-w-full space-y-6'>
        {/* Tag List and Trend Analysis */}
        <AssetTagTrend
          tagTrendData={tagTrendData}
          compressor={compressor}
          downtimeEvents={downtimeEvents}
          layout={{ type: "trends", showTrendAlways: true }}
        />
      </div>
    </AssetLayout>
  );
}
